// extracted by mini-css-extract-plugin
export default {"companyContainer":"bL-z","companyImage":"cL-z","container":"dL-z","heading":"eL-z","darkText":"fL-z","smallHeading":"gL-z","darkBackground":"hL-z","whiteBackground":"iL-z"};